import React from 'react';
import styled from 'styled-components';
import { NotificationManager } from 'react-notifications';
import { DragDropContext, Draggable, Droppable, resetServerContext } from 'react-beautiful-dnd';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { palette } from '../../system/styles/styles';
import {
  getData,
  Post_Multi_Candidate,
  postComment,
  postStar,
  updateComment,
  updateStar,
} from '../../redux/actions/applicantActions';
import {
  ac_Drag_column_firebaser,
  action_Drag_Candidate,
  action_Drag_Candidate_Organic,
  addColumn,
  deleteColumn,
  DragColumn,
  getActivity,
  Load_Email_Format,
  postComent,
  sendActivity,
  updateNameColumn,
} from '../../redux/actions/backendActions';
import Header from '../components/ats/header';
import Applicant from '../components/ats/applicant';
import Droppabled from '../components/ats/droppable';
import ModalCandidate from '../components/ats/modalCandidate';
import Pupop from '../components/ats/popup';

const MainContainer = styled.main`
  max-height: 100%;
  padding: 6px 0px 16px 16px;
  width: calc(100% - 30px);
  .leftBox {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .button__submit__ {
    background-color: ${palette.blue};
    color: #fff;
    margin: 12px;
    font-size: 18px;
    border: none;
    padding: 9px 13px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
  }
  .grid-2 {
    position: relative;
    display: grid;
    grid-gap: 32px;
    grid-template-columns: repeat(2, 1fr);
  }
  .grid-1 {
    position: relative;
    display: grid;
    grid-gap: 32px;
    grid-template-columns: 1fr;
  }
  .titleMain {
    font-size: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    letter-spacing: 0.5px;
    font-weight: 400;
    text-transform: uppercase;
  }
  .grid-end {
    justify-self: end;
  }
  .title {
    display: grid;
    grid-template-columns: calc(100% - 25px) 25px;
    margin-bottom: 5px;
    align-items: center;
  }
  .title img {
    width: 20px;
    height: 20px;
  }
  .title button {
    background-color: transparent;
    max-width: 25px;
    min-width: 25px;
    height: 25px;
    align-items: center;
    justify-content: center;
    padding: 0px;
    cursor: pointer;
  }
  .Panel {
    position: absolute;
    width: 40vw !important;
    height: 0px;
    border-radius: 40px;
    background-color: #fff;
    box-shadow: 0 13px 33px 0 rgba(0, 0, 0, 0.3);
    margin-left: 250px;
    left: calc((100vw - 40vw - 250px) / 2);
    top: calc(100vh - 100px);
    transform: scale(0);
    transition: cubic-bezier(0.075, 0.82, 0.165, 1) 0.6s;
    opacity: 0;
  }
  .showPanel_combo {
    position: absolute;
    width: 40vw !important;
    height: 80px;
    border-radius: 40px;
    background-color: #fff;
    box-shadow: 0 13px 33px 0 rgba(0, 0, 0, 0.3);
    //margin-left: 250px;
    left: calc((100vw - 40vw - 250px) / 2);
    top: calc(100vh - 100px);
    transform: scale(1);
    transition: cubic-bezier(0.075, 0.82, 0.165, 1) 0.6s;
    opacity: 1;
  }
  .change_multicheck {
    display: grid;
    height: 100%;
    width: 100%;
    grid-template-columns: 40% 30% 30%;
    //padding:  10% 0%;
  }
  .combo_box {
    display: flex;
    margin: auto;
    width: 80%;
  }
  .combo_buttom {
    background-color: ${palette.black};
    color: ${palette.white};
    height: 50%;
    padding: 3%;
    align-self: center;
  }
  .droppable {
    display: flex;
    //min-width: calc(100vw - 178px);
    max-width: calc(96vw - 178px);
    min-height: calc(100vh - 136px);
    max-height: calc(100vh - 70px);
    transition: 1.4s;
    overflow-y: hidden;
    position: absolute;
    background-color: #f9faff;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 5px;
    }

    overflow-x: auto;
  }
  .columns {
    flex-direction: row;
    display: flex;
    padding-left: 25px;
    padding-right: 25px;
  }
  .less-columns {
    width: auto;
    flex-direction: row;
    display: flex;
    padding-left: 20px;
    gap: 15px;
  }
  .up {
    top: 116px;
    opacity: 1;
  }

  .down {
    top: 100vh;
    opacity: 0;
    transform: scale(0.9);
    display: none;
  }
  .box-ats {
    padding: 14px;
    background-color: ${palette.white};
    border-radius: 8px;
    //min-height: calc(94vh - 87px);
    box-shadow: -5px 5px 2px 2px rgb(0 0 0 / 16%);
    margin: 10px;
  }
  .extra {
    &::-webkit-scrollbar {
      width: 0.5em;
      height: 0.5em;
    }
    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 0.5rem;
    }
    max-width: 317px;
    min-width: 317px;
    overflow-y: auto;
  }
  .box-ats h4 {
    font-size: 16px;
    font-family: 'pieza-bold', sans-serif;
    text-align: center;
    //margin-bottom: 10px;
  }
  .box-proccess {
    width: 317px;
    margin-left: 10px;
  }
`;

const ATS = () => {
  const dispatch = useDispatch();
  const { vacancyId } = useParams();
  const history = useHistory();
  const { load, column: parsedFetch, candidates_Store } = useSelector((state) => state.backend?.vacancy || {});
  const Check_Candidate = useSelector((state) => state?.backend?.vacancy?.Check_Candidate);
  const columns = useSelector((state) => state.backend?.vacancy?.column);
  const candidates = useSelector((state) => state.backend?.vacancy?.candidates);
  const { vacancies } = useSelector((state) => state);
  const uid = useSelector((state) => state?.auth?.uid);
  const infoCandidate = useSelector((state) => state.backend?.vacancy?.info);
  const userData = useSelector((state) => state.auth.userData);
  const [state, setState] = React.useState({
    canidateToView: undefined,
    columnNameEditor: '',
    isLoading: true,
    canidates: [],
    store: [],
    boxes: [],
    count: 0,
    numPages: 0,
    pageNumber: 1,
    showModal: false,
    job: {
      jobTitle: 'loading',
    },
    error: '',
    data: [],
    titleVacancy: 'loading',
    optionsSelect: '',
    users: [],
    menusOpen: [],
    ModalViewCandidate: {},
    ModalViewOpen: false,
    Save: [],
    column: '',
    showCombo: false,
    Array_Candidate_column: [],
  });
  const loadMain = () => {
    // Aqui es se busca la info de la vacante para cargar datos
    const findVacancy = vacancies.find((vacan) => vacan?.jobID === vacancyId);
    setState((prev) => ({
      ...prev,
      job: findVacancy,
    }));
    dispatch(getData({ uid, id: vacancyId }));
    dispatch(getActivity({ uid, id: vacancyId }));
    dispatch(Load_Email_Format());
  };

  React.useEffect(() => {
    loadMain();
  }, []);

  const ToggleCheckBox = async (info) => {
    // console.log(info)
    // console.log(this.state.Array_Candidate_column)
    if (state.Array_Candidate_column.length < 1) {
      const Arraytemp = [info];
      await setState((prevState) => ({
        ...prevState,
        showCombo: !prevState.showCombo,
        Array_Candidate_column: Arraytemp,
      }));
      await dispatch(Post_Multi_Candidate(Arraytemp));
    } else {
      const ArrayT_two = state.Array_Candidate_column.slice();
      const splice = ArrayT_two.filter((e) => e.idUser === info.idUser);
      // console.log(splice);
      if (splice.length <= 0) {
        await ArrayT_two.push(info);
        // console.log(ArrayT_two);
        await setState((prev) => ({ ...prev, Array_Candidate_column: ArrayT_two }));
        await dispatch(Post_Multi_Candidate(ArrayT_two));
      } else {
        const remove = ArrayT_two.filter((e) => e.idUser !== info.idUser);
        await setState((prev) => ({ ...prev, Array_Candidate_column: remove }));
        await dispatch(Post_Multi_Candidate(remove));
        if (state.Array_Candidate_column < 1) {
          await setState((prevState) => ({
            ...prevState,
            showCombo: !prevState.showCombo,
          }));
        }
      }
    }
    // console.log(this.state.Array_Candidate_column)
  };

  const changeColumnEditor = async (id) => {
    await setState((prev) => ({
      ...prev,
      columnNameEditor: id,
      nameColumn: {
        name: '',
        id: '',
      },
    }));
  };

  const deletecolumn = (e) => {
    const comfirm = window.confirm('Seguro de eliminar columna los candidatos volverán a la primera columna');
    if (!comfirm) return;
    dispatch(deleteColumn({ uid, url: vacancyId, key: e }));
  };

  const Load_Save = () => {
    return [];
  };

  const ProcessInicial = (data) => {
    const tempBoxes = [];
    if (data) {
      data.map((value, index) => {
        tempBoxes.push(
          <Droppabled
            value={value}
            comboBox_Fuction={ToggleCheckBox}
            data={data}
            index={index}
            column_names={parsedFetch}
            candidates={candidates_Store}
            uid={uid}
            idVacancy={vacancyId}
            columnNameEditor={state.columnNameEditor}
            changeColumnEditor={changeColumnEditor}
            deleteCanidates_View={deletecolumn}
            Open_ClosedModal={Open_ClosedModal}
            Load_Save={Load_Save}
            closeName={() => setState((prev) => ({ ...prev, columnNameEditor: '' }))}
          />
        );
      });
      setState((prev) => ({ ...prev, boxes: [] }));
      setState((prev) => ({ ...prev, boxes: tempBoxes }));
    }
  };
  React.useEffect(() => {
    if (load === false) {
      ProcessInicial(parsedFetch);
    }
  }, [load, state.columnNameEditor]);
  const prevPage = () => {
    history.goBack();
  };
  const AddColumnFirebase = () => {
    dispatch(addColumn({ uid, url: vacancyId, columns }));
  };

  const reorden_candidate = (columns, idto, idfrom, indexto, indexfrom) => {
    // IFROM = DE QUE TABLA SALIO
    // ITO = A QUE TABLA ENTRARA
    const url = vacancyId;
    const columns_copy = columns.slice();
    if (idfrom === 'canidates') {
      const column_from = Array.from(candidates);
      const column_to = Array.from(
        columns.find((e) => e.docID === idto).candidates ? columns.find((e) => e.docID === idto).candidates : []
      );
      const [removed] = column_from.splice(indexfrom, 1);
      const temp_json = {
        sortIndex: indexto,
        idUser: removed.docID,
      };
      column_to.splice(indexto, 0, temp_json);
      // columns_copy contine las columnas actualizadas /// column_from = candidates actualizado
      columns_copy.find((o) => {
        if (o.docID === idto) {
          o.candidates = column_to;
        }
      });
      dispatch(
        action_Drag_Candidate_Organic({
          candidate: column_from,
          columns: columns_copy,
        })
      );

      dispatch(
        ac_Drag_column_firebaser(
          {
            uid,
            vacancy: vacancyId,
          },
          columns_copy
        )
      );

      dispatch(
        sendActivity(
          {
            id_company: uid,
            vacancy: url,
            type: 'drag',
            to: idto,
            from: idfrom,
            candidate: removed.docID,
          },
          removed
        )
      );
    } else if (idto === 'canidates') {
      const column_to = Array.from(candidates);
      const column_from = Array.from(
        columns.find((e) => e.docID === idfrom).candidates ? columns.find((e) => e.docID === idfrom).candidates : []
      );
      // console.log(column_from,column_to)
      const [removed] = column_from.splice(indexfrom, 1);
      // console.log(removed)
      const temp_json = candidates_Store.find((e) => e.docID == removed.idUser);
      column_to.splice(indexto, 0, temp_json);
      // columns_copy contine las columnas actualizadas /// column_from = candidates actualizado
      Object.keys(column_from).map((key) => {
        column_from[key].sortIndex = +key;
      });
      columns_copy.find((o) => {
        if (o.docID === idfrom) {
          o.candidates = column_from;
        }
      });
      // console.log(columns_copy,column_to)
      dispatch(
        action_Drag_Candidate_Organic({
          candidate: column_to,
          columns: columns_copy,
        })
      );
      dispatch(
        ac_Drag_column_firebaser(
          {
            uid,
            vacancy: vacancyId,
          },
          columns_copy
        )
      );
      dispatch(
        sendActivity(
          {
            id_company: uid,
            vacancy: url,
            type: 'drag',
            to: idto,
            from: idfrom,
            candidate: removed.idUser,
          },
          removed
        )
      );
    } else {
      const column_from = Array.from(
        columns.find((e) => e.docID === idfrom).candidates ? columns.find((e) => e.docID === idfrom).candidates : []
      );
      const column_to = Array.from(
        columns.find((e) => e.docID === idto).candidates ? columns.find((e) => e.docID === idto).candidates : []
      );
      const [removed] = column_from.splice(indexfrom, 1);
      column_to.splice(indexto, 0, removed);
      // columns_copy contine las columnas actualizadas /// column_from = candidates actualizado
      Object.keys(column_to).map((key) => {
        column_to[key].sortIndex = +key;
      });
      Object.keys(column_from).map((key) => {
        column_from[key].sortIndex = +key;
      });
      columns_copy.find((o) => {
        if (o.docID === idto) {
          o.candidates = column_to;
        }
        if (o.docID == idfrom) {
          o.candidates = column_from;
        }
      });
      dispatch(
        action_Drag_Candidate({
          columns: columns_copy,
        })
      );
      dispatch(
        ac_Drag_column_firebaser(
          {
            uid,
            vacancy: vacancyId,
          },
          columns_copy
        )
      );
      dispatch(
        sendActivity(
          {
            id_company: uid,
            vacancy: url,
            type: 'drag',
            to: idto,
            from: idfrom,
            candidate: removed.idUser,
          },
          removed
        )
      );
    }
  };
  const reorden_in_column = (columns, indexto, indexfrom, idcolumn) => {
    // indexfrom) = DE QUE index SALIO
    // indexto = A QUE index ENTRARA}
    const columns_copy = columns.slice();
    const result = Array.from(columns.find((e) => e.docID === idcolumn).candidates);
    const [removed] = result.splice(indexfrom, 1);
    result.splice(indexto, 0, removed);
    Object.keys(result).map((key) => {
      result[key].sortIndex = +key;
    });
    columns_copy.find((o) => {
      if (o.docID === idcolumn) {
        o.candidates = result;
      }
    });
    dispatch(
      action_Drag_Candidate({
        columns: columns_copy,
      })
    );
    dispatch(
      ac_Drag_column_firebaser(
        {
          uid,
          vacancy: vacancyId,
        },
        columns_copy
      )
    );
  };

  const onDragEnd = async (result) => {
    if (!result.destination) return;
    const canidates = {};
    if (columns[columns.length - 2].docID == result.destination.droppableId) {
      const _t_ = window.confirm(
        '¿Estás seguro de rechazar? Se enviará un email al postulante notificando su rechazo.'
      );
      if (!_t_) return;
    }
    if (columns[columns.length - 1].docID == result.destination.droppableId) {
      const _t_ = window.confirm(
        '¿Estás seguro de aceptar? Se enviará un email al postulante notificando su aceptacón.'
      );
      if (!_t_) return;
    }
    // console.log(result.destination.droppableId)
    if (result.destination.droppableId != 'board') {
      if (result.source.droppableId === result.destination.droppableId) {
        if (result.source.droppableId !== 'canidates') {
          reorden_in_column(columns, result.source.index, result.destination.index, result.source.droppableId);

          // let data = [];
          // canidates.map(o => {
          //     const temp = {};
          //     temp.sortIndex = o.index;
          //     temp.idUser = o.docID;
          //     data.push(temp);
          // });
          // const temp = this.props.column_names.find(e => e.document == result.source.droppableId);
          // if (typeof temp !== 'undefined') data.name = this.props.column_names.find(e => e.document == result.source.droppableId).name
          // if (typeof temp === 'undefined') data.name = 'Sin nombre'
          // this.props.updateColumnCanidateFirestone({
          //     uid: uid,
          //     url: url,
          //     id: result.source.droppableId,
          //     canidates: data,
          //     data: canidates
          // })
        } else {
          NotificationManager.info('En la columna de Nuevo aplicante, no se puede modificar el orden');
          // canidates = reorder(
          //     this.props.canidates,
          //     result.source.index,
          //     result.destination.index
          // );
          // this.props.updateColumnCanidate({id: 'canidates', canidates: canidates})
        }
      } else {
        if (result.destination.droppableId !== 'canidates' && result.source.droppableId !== 'canidates') {
          reorden_candidate(
            columns,
            result.destination.droppableId,
            result.source.droppableId,
            result.destination.index,
            result.source.index
          );

          // this.props.sendActivity({
          //         id: url,
          //         type: 'drag',
          //         to: result.destination.droppableId,
          //         from: result.source.droppableId,
          //         candidate: reorden[3][index2].docID
          //     })
          //     const index = result.source.index;
          //     const array = this.props.columns[result.source.droppableId];
          //     const index2 = result.destination.index;
          //     const array2 = this.props.columns[result.destination.droppableId];
          //     const reorden = this.reorden(array, array2, index, index2, result.source.droppableId, result.destination.droppableId);
          //     this.props.updateColumnCanidateFirestone({
          //         uid: uid,
          //         url: url,
          //         id: result.source.droppableId,
          //         canidates: reorden[0],
          //         data: reorden[2],
          //         update: true
          //     })
          //     this.props.updateColumnCanidateFirestone({
          //         uid: uid,
          //         url: url,
          //         id: result.destination.droppableId,
          //         canidates: reorden[1],
          //         data: reorden[3]
          //     })
          //     this.sendEmailUser(result.destination.droppableId)
          //     this.props.sendActivity({
          //         id: url,
          //         type: 'drag',
          //         to: result.destination.droppableId,
          //         from: result.source.droppableId,
          //         candidate: reorden[3][index2].docID
          //     })
          //
          NotificationManager.success('El candidato fue movido exitosamente');
        } else if (result.destination.droppableId === 'canidates') {
          // console.log('Que pasa aki')
          // const index = result.source.index;
          // const array = this.props.columns.find(e=>e.docID === result.source.droppableId);
          // const index2 = result.destination.index;
          // const array2 = this.props.candidates;
          reorden_candidate(
            columns,
            result.destination.droppableId,
            result.source.droppableId,
            result.destination.index,
            result.source.index
          );
          // this.props.updateColumnCanidateFirestone({
          //     uid: uid,
          //     url: url,
          //     id: result.source.droppableId,
          //     canidates: reorden[0],
          //     data: reorden[2]
          // })
          //
          // this.props.updateColumnCanidate({id: 'canidates', canidates: reorden[3]})
          //
          // this.props.sendActivity({
          //     id: url,
          //     type: 'drag',
          //     to: result.destination.droppableId,
          //     from: result.source.droppableId,
          //     candidate: reorden[3][index2].docID
          // })
          NotificationManager.success('El candidato fue movido exitosamente');
        } else if (result.source.droppableId === 'canidates') {
          // const array = this.props.candidates;
          // const array2 = this.props.columns.find(e=>e.docID === result.destination.droppableId);
          // const index = result.source.index;
          // const index2 = result.destination.index;
          reorden_candidate(
            columns,
            result.destination.droppableId,
            result.source.droppableId,
            result.destination.index,
            result.source.index
          );

          // this.props.updateColumnCanidateFirestone({
          //     uid: uid,
          //     url: url,
          //     id: result.destination.droppableId,
          //     canidates: reorden[1],
          //     data: reorden[3]
          // })
          //
          // this.props.updateColumnCanidate({id: 'canidates', canidates: reorden[2]})
          // this.sendEmailUser(result.destination.droppableId)
          // this.props.sendActivity({
          //     id: url,
          //     type: 'drag',
          //     to: result.destination.droppableId,
          //     from: result.source.droppableId,
          //     candidate: reorden[3][index2].docID
          // })
          NotificationManager.success('El candidato fue movido exitosamente');
        }

        // if (this.props.column_names[this.props.column_names.length - 2].document == result.destination.droppableId) {
        //     setTimeout(() => {
        //         const {droppableId, index} = result.destination;
        //         const user = this.props.columns[droppableId][index];
        //         const job = this.state.job;
        //         this.props.sendEmailDeclineJob({
        //             puesto: user.jobName,
        //             company: job.companyName,
        //             fname: user.names,
        //             lname: user.lastName,
        //             email: user.email,
        //             idUser: user.docID,
        //             uid: uid,
        //             id: url
        //         });
        //     }, 3000);
        // }
        //
        // if (this.props.column_names[this.props.column_names.length - 1].document == result.destination.droppableId) {
        //     setTimeout(() => {
        //         const {droppableId, index} = result.destination;
        //         const user = this.props.columns[droppableId][index];
        //         this.props.rejectPostulante({
        //             user,
        //             uid: uid,
        //             id: url,
        //         });
        //     }, 3000);
        // }
      }
    } else {
      //    Funcion cambio de columna
      const from = columns.find((o) => o.index === result.source.index);
      const to = columns.find((o) => o.index === result.destination.index);

      if (
        !from ||
        (!to && to.index === from.index) ||
        to.index === columns.length - 2 ||
        to.index === columns.length - 1 ||
        from.index === columns.length - 2 ||
        from.index === columns.length - 1
      ) {
        NotificationManager.error('Esta columna no puede manipularse', '', 3000);
        return;
      }

      // console.log(result,this.props.columns)
      dispatch(
        DragColumn(
          {
            vacancy: vacancyId,
            to,
            from,
          },
          columns
        )
      );
      NotificationManager.success('Columnas actulizadas');
    }
  };

  const Open_ClosedModal = (data) => {
    setState((prevState) => ({
      ...prevState,
      ModalViewOpen: !prevState.ModalViewOpen,
      Save: data,
    }));
  };

  // Metodo para el modal
  const onDocumentLoadSuccess = ({ numPages }) => {
    setState((prev) => ({ ...prev, numPages }));
  };
  const goBackPage = () => {
    setState((prevState) => ({
      ...prevState,
      pageNumber: prevState.pageNumber - 1,
    }));
  };

  const advancePage = () => {
    setState((prevState) => ({
      ...prevState,
      pageNumber: prevState.pageNumber + 1,
    }));
  };

  const sendComment = async (message = '', idAplicant = 0, initial = true, idColumn = '') => {
    if (message !== '') {
      let comments = [];
      if (initial != true) comments = Object.values(initial);
      let tempCanidates = null;
      // console.log(idColumn)
      if (idColumn === 'canidates') {
        tempCanidates = candidates;
      } else {
        tempCanidates = columns.find((e) => e.docID === idColumn);
      }
      // console.log(tempCanidates)
      const indexAplicant = candidates_Store.findIndex((e) => e.docID == idAplicant || e.idUser == idAplicant);
      const Aplicants = candidates_Store.find((e) => e.docID == idAplicant || e.idUser == idAplicant);
      const id = vacancyId;

      comments.push({
        userID: uid,
        // userName: this.props.userData.displayName,
        timestamp: moment().valueOf(),
        comentario: message,
        edited: false,
        email: userData.email,
        subComments: [{}],
      });
      Aplicants.Comments = comments;
      tempCanidates[indexAplicant] = Aplicants;

      dispatch(postComent({ id: idColumn, data: tempCanidates }));
      dispatch(postComment({ idAplicant, uid, comments, Aplicants, id }));
    } else {
      NotificationManager.error('No se puede enviar comentarios vacios');
    }
    dispatch(
      sendActivity({
        id: vacancyId,
        vacancy: vacancyId,
        id_company: uid,
        type: 'comment-post',
        to: '',
        from: '',
        candidate: idAplicant,
      })
    );
  };
  const updateCommentLocal = (message = '', index = -1, idAplicant = 0, idColumn = '') => {
    let tempCanidates = null;
    if (idColumn === 'canidates') {
      tempCanidates = candidates;
    } else {
      tempCanidates = columns.find((e) => e.docID === idColumn);
    }
    const indexAplicant = candidates_Store.findIndex((e) => e.docID == idAplicant || e.idUser == idAplicant);
    // console.log(candidates_Store.find(e => e.docID == idAplicant || e.idUser == idAplicant))
    candidates_Store.find((e) => e.docID == idAplicant || e.idUser == idAplicant).Comments.reverse()[index].comentario =
      message;
    candidates_Store.find((e) => e.docID == idAplicant || e.idUser == idAplicant).Comments.reverse()[
      index
    ].edited = true;
    const comments = candidates_Store.find((e) => e.docID == idAplicant || e.idUser == idAplicant).Comments;
    const Aplicants = candidates_Store.find((e) => e.docID == idAplicant || e.idUser == idAplicant);
    const id = vacancyId;
    dispatch(postComent({ id: idColumn, data: tempCanidates }));
    dispatch(updateComment({ idAplicant, uid, comments, Aplicants, id }));
    dispatch(
      sendActivity({
        id: vacancyId,
        vacancy: vacancyId,
        id_company: uid,
        type: 'comment-update',
        to: null,
        from: null,
        candidate: idAplicant,
      })
    );
  };
  const getUserData = (data, idColumn) => {
    const { star, docID, Star } = data;
    const doc = vacancyId;
    let tempCanidates = null;
    // console.log(idColumn,this.props.columns)
    if (idColumn === 'canidates') {
      tempCanidates = candidates;
    } else {
      tempCanidates = columns.find((e) => e.docID === idColumn);
    }
    // console.log(tempCanidates)
    const indexAplicant = candidates_Store.findIndex((e) => e.docID == docID || e.idUser == docID);

    const Aplicants = candidates_Store.find((e) => e.docID == docID || e.idUser == docID);
    const { email } = userData;
    const aplicant = docID;
    const userName = userData?.displayName;
    const userID = uid;
    return {
      star,
      docID,
      Star,
      uid,
      doc,
      tempCanidates,
      indexAplicant,
      Aplicants,
      email,
      aplicant,
      userName,
      userID,
    };
  };

  const postStarOn = (data, idColumn) => {
    const {
      star,
      Star,
      doc,
      tempCanidates,
      indexAplicant,
      Aplicants,
      email,
      aplicant,
      userName,
      userID,
      edited = false,
    } = getUserData(data, idColumn);
    // this.props.sendActivity({
    //     id: this.props.match.params.id,
    //     type: 'star-post',
    //     to: null,
    //     from: null,
    //     candidate: aplicant
    // })
    const timestamp = moment().valueOf();
    const sendable = {
      Star,
      star,
      doc,
      edited,
      aplicant,
      email,
      userName,
      userID,
      timestamp,
      vacancyOwner: vacancyId,
    };
    let history = [];
    let tmp = [];
    let promedio = 0;
    const array = {
      edited,
      email,
      timestamp,
      userID,
      userName,
      star,
    };

    if (Star !== false) {
      history = [];
      Star.items.map((e) => {
        history.push(e);
        promedio += e.star;
      });
      promedio += star;
      promedio /= history.length + 1;
      history.push(array);
      const tmp = {
        items: {
          ...history,
        },
        promedio: promedio.toFixed(1),
      };
      Aplicants.stars = tmp;
    } else {
      history.push(array);
      tmp = {
        items: {
          ...history,
        },
        promedio: star,
      };
      Aplicants.stars = tmp;
    }
    dispatch(postStar(JSON.parse(JSON.stringify(sendable))));
    tempCanidates[indexAplicant] = Aplicants;
    dispatch(postComent({ id: idColumn, data: tempCanidates }));
  };

  const Active_Load_Save = () => {
    setState((prev) => ({ ...prev, Save: Load_Save() }));
  };

  const updateStarLocal = async (data, idColumn) => {
    const {
      star,
      uid,
      doc,
      tempCanidates,
      indexAplicant,
      Aplicants,
      aplicant,
      edited = true,
    } = getUserData(data, idColumn);
    let promedio = 0;
    const items = [];
    // console.log(Aplicants)
    // this.props.sendActivity({
    //     id: this.props.match.params.id,
    //     type: 'star-update',
    //     to: null,
    //     from: null,
    //     candidate: aplicant
    // })

    Object.values(Aplicants.stars.items).map((e) => {
      if (e.userID == uid) {
        e.star = star;
        e.edited = true;
      }
      promedio += e.star;
      items.push(e);
    });

    Aplicants.stars.items = items;
    promedio /= Aplicants.stars.items.length;

    const sendable = {
      history: Aplicants.stars.items,
      star,
      doc,
      edited,
      aplicant,
      userID: uid,
      promedio: promedio.toFixed(1),
      idColumn,
      docID: data.docID,
    };
    dispatch(updateStar(sendable));
    tempCanidates[indexAplicant] = Aplicants;
    dispatch(postComent({ id: idColumn, data: tempCanidates }));
    const temp_p = state.boxes.slice();
    await setState((prev) => ({ ...prev, boxes: [] }));
    await setState((prev) => ({ ...prev, boxes: temp_p }));
  };

  return (
    <MainContainer>
      {resetServerContext()}
      {state?.ModalViewOpen ? (
        <ModalCandidate
          openModal={state?.ModalViewOpen}
          load_success={onDocumentLoadSuccess}
          go_back={goBackPage}
          advance_page={advancePage}
          info={{
            ...infoCandidate,
            Save: state.Save,
          }}
          numPages={state.numPages}
          pageNumber={state.pageNumber}
          sendComment={sendComment}
          saveEditComment={updateCommentLocal}
          postStar={postStarOn}
          updateStar={updateStarLocal}
          Load_Save={Active_Load_Save}
          close={Open_ClosedModal}
          jobID={vacancyId}
        />
      ) : null}

      <Header
        onClick={prevPage}
        title={state.job.jobTitle}
        // addCanidate={this.addCanidate}
        _AddColumnFirebase={AddColumnFirebase}
        // totalCandidates={this.props.totalCandidates}
        // volumenVacancy={this.props.volumenVacancy}
        // job={this.state.job}
      />
      <div className="droppable">
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="board" type="COLUMN" direction="horizontal" isCombineEnabled>
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className={`grid-${state.boxes.length} ${state.boxes.length > 3 ? 'columns' : 'less-columns'}`}>
                <Droppable droppableId="canidates">
                  {(provided, snapshot) => (
                    <div {...provided.droppableProps} ref={provided.innerRef} className="box-ats extra">
                      <div key="candidates" className="title">
                        <h4
                          style={{
                            marginBottom: '10px',
                          }}>
                          {' '}
                          Nuevos Candidatos
                        </h4>

                        {/* <Pupop */}
                        {/*    id="canidates" */}
                        {/*    inputcheck={Check_Candidate} */}
                        {/*    // onEdit={this.changeColumnEditor} */}
                        {/*    // onRemove={this.deleteCanidates_View} */}
                        {/*    edit="candidates" */}
                        {/*    sendable={{ */}
                        {/*        id: "canidates", */}
                        {/*        uid, */}
                        {/*        idVacancy: vacancyId, */}
                        {/*    }} */}
                        {/*    // open={this.onOpenModal} */}
                        {/* /> */}
                      </div>
                      {/* Esto podría generar problemas. */}
                      {candidates
                        ?.sort((a, b) => a.time - b.time)
                        .reverse()
                        .map((canidate, idx) => (
                          <Draggable key={idx} draggableId={`${idx}`} index={idx}>
                            {(provided, snapshot) => (
                              <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                <Applicant
                                  idColumn="canidates"
                                  inputcheck={Check_Candidate}
                                  _column={0}
                                  // data={this.props.userData}
                                  info={canidate}
                                  // setDownload={this.setViewed}
                                  idVacancy={vacancyId}
                                  key={`${canidate.names}_${idx}`}
                                  // _sendComment={this.sendComment}
                                  // _updateStar={this.updateComment}
                                  // _postStar={this.postStar}
                                  // updateStar={this.updateStar}
                                  Open_ClosedModal={Open_ClosedModal}
                                  // Load_Save={this.Load_Save}
                                  comboBox_Fuction={ToggleCheckBox}
                                />
                              </div>
                            )}
                          </Draggable>
                        ))}
                    </div>
                  )}
                </Droppable>
                {state.boxes.map((e, index) => {
                  return (
                    <Draggable key={index} draggableId={`array_${index}`} index={index}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="box-ats box-proccess">
                          {e}
                        </div>
                      )}
                    </Draggable>
                  );
                })}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </MainContainer>
  );
};

export default ATS;
